import React, {Component} from 'react';
import {ContentDiv, BodyHeaderDiv, BodyHeaderText, SubmitBtn, MidCifBtn} from '../theme/MorsTheme';
import {Row,Col,Form, Modal,Pagination} from 'react-bootstrap';
import {getUserMIDList} from '../Utilities/WSUtil'
import {Link} from 'react-router-dom';

export default class MerchantPicker extends Component{
    constructor(props){
        super(props);        
        this.state = {                                 
            USER:JSON.parse(localStorage.getItem("USER")),                      
            checkedAllReport:false, 
            searchSingleId: '',
            midList:[],
            open: false,
            show: false,
            todos:[],
            currentPage: 1,
            todosPerPage: 20,
            totalPage:1       
        };
        this.handleClick = this.handleClick.bind(this);
        this.modalHide = this.modalHide.bind(this);
        this.modalShow = this.modalShow.bind(this);

      
    }   
    
    modalShow(event){       
        event.preventDefault();

        getUserMIDList(this.props.userId)
        .then(response => {
        
            this.setState({
                midList: response,
                todos: response
            }) 
            
            var totalP= Math.ceil(this.state.todos.length/this.state.todosPerPage)
            this.setState({totalPage: totalP});
        }).catch(error =>{            
            this.setState({
                fetchMessage: 'Invalid Merchant ID', loading:false,
            })                                     
        
        })

        
        this.setState({ show: true});

    }

    modalHide(event) {
        event.preventDefault(); 
        this.setState({ show: false });     
    }

    selectModal(val){
        this.props.getMerchant(val)   
        this.setState({ show: false });      
    }
    setPage(page){
        if(page>=1 && page<=this.state.totalPage)
        this.setState({
            currentPage: Number(page)
          });
    }
    handleClick(event) {
        this.setState({
          currentPage: Number(event.target.id)
        });
    }

    render(){
        const { todos, currentPage, todosPerPage } = this.state;

        // Logic for displaying todos
        const indexOfLastTodo = currentPage * todosPerPage;
        const indexOfFirstTodo = indexOfLastTodo - todosPerPage;
        const currentTodos = todos.slice(indexOfFirstTodo, indexOfLastTodo);

        const renderTodos = currentTodos.map((todo, index) => {
        return <li key={index}>{todo}</li>;
        });

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(todos.length / todosPerPage); i++) {
        pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
              <li
                key={number}
                id={number}
                onClick={this.handleClick}
              >
                {number}
              </li>
            );
          });

        var pager = this.state.pager;
        return(
            <div>
            <Row style={{paddingLeft:'5px'}} >
                <MidCifBtn onClick={this.modalShow}>...</MidCifBtn>                                     
            </Row>

            <Modal  dialogClassName="modal-bdo" show={this.state.show} backdrop={'static'}  onHide={this.modalHide} centered={true} backdropClassName='fade'>                
                    <Modal.Header style={{backgroundColor:'#0B2972', height:'40px', padding:'15px, 0px'}}>                      
                        <Modal.Title style={{fontSize:'14px', color:'white'}}><span>Merchant Picker</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body >    
                        
                                <Row align="center">
                                    <Col md={2} xs={2}></Col>   
                                    <Col md={3} xs={3}>MID</Col>   
                                    <Col md={6} xs={6} align="left" >DBA NAME</Col>                             
                                </Row>
                                
                                {/* {this.state.midList.map((item, index) =>*/}
                                {currentTodos.map((todo, index) =>                                                             
                                    <Row align="center" key={index} style={{fontSize:'12px'}}>   
                                        <Col md={2} xs={2}></Col>   
                                        <Col md={3} xs={3}>                                
                                            <a onClick={() =>this.selectModal(todo)}>{todo.id}</a> 
                                        </Col>
                                        <Col md={7} xs={7} align="left">                                
                                            {todo.dbaName}
                                        </Col>
                                    </Row>
                                )} 

                                <div align="center" style={this.state.todos.length !== 0 ? {display:'block', marginTop: '20px'}: {display:'none'}}>                            
                                <Pagination style={{display: 'flex', justifyContent:'center'}}>
                                    <Pagination.First onClick={() => this.setPage(1)} />                                                                        
                                    <Pagination.Prev onClick={() => this.setPage(this.state.currentPage - 1)}/>                                                                        
                                    <Pagination.Next onClick={() => this.setPage(this.state.currentPage + 1)}/>
                                    <Pagination.Last onClick ={() => this.setPage(this.state.totalPage)}/>                     
                                </Pagination>                                             
                                
                                    <div align="center">
                                        <span>Page {this.state.currentPage}</span> / {" "}                            
                                        <span>{this.state.totalPage}</span>
                                    </div>  
                                </div>

                                <Row align="center" style={{paddingTop: '10px'}}>
                                    <Col>
                                        {/* <SubmitBtn onClick={()=> this.props.getMerchant("000000")}>Yes</SubmitBtn> */}
                                        <SubmitBtn onClick={this.modalHide}>CLOSE</SubmitBtn>    
                                    </Col>
                                </Row>                        
                    </Modal.Body>                                                               
            </Modal>  
            </div>
        )
    }
}